import React from "react";

export type TextareaProps = {
  id?: string;
  label?: string;
  width: string;
  placeholder: string;
  extraClasses: string;
  required: boolean;
  value?: string;
  onChange?: (name: string, value: string) => void;
  name: string;
  rows?: number;
};

export default function Textarea({
  id,
  label,
  width,
  placeholder,
  extraClasses,
  required,
  value,
  onChange,
  name,
  rows = 4, // default to 4 rows
}: TextareaProps) {
  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onChange) onChange(name, e.target.value);
  };

  return (
    <div className="form-group">
      {label && <label htmlFor={id || name}>{label}</label>}
      <textarea
        id={id || name}
        className={`${extraClasses} w-${width} border rounded px-2 py-1`}
        placeholder={placeholder}
        required={required}
        value={value}
        onChange={handleInputChange}
        rows={rows}
      />
    </div>
  );
}
